import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "app-inspect",
  "use": "app-inspect-usage",
  "viewBox": "0 0 50 50",
  "content": "<symbol viewBox=\"0 0 50 50\" id=\"app-inspect\"><defs><style>#app-inspect .cls-1{fill:#30c790;}#app-inspect .cls-2{fill:#fff;}</style></defs><title>资源 28</title><g id=\"app-inspect_图层_2\" data-name=\"图层 2\"><g id=\"app-inspect_图层_1-2\" data-name=\"图层 1\"><rect class=\"cls-1\" width=\"50\" height=\"50\" /><path class=\"cls-2\" d=\"M39,13.64l-1.3,0a18.54,18.54,0,0,1-6-1.3,27.8,27.8,0,0,1-5.1-2.75L25.81,9,25,9.58a25.62,25.62,0,0,1-5.1,2.75,18.62,18.62,0,0,1-6,1.3l-1.32,0V27.1c0,6.76,8.56,13.9,13.16,13.9S39,33.86,39,27.1ZM29.27,26.72H27.54v2.58a1.72,1.72,0,0,1-3.45,0V26.72H22.37a1.72,1.72,0,0,1,0-3.45h1.72V20.69a1.72,1.72,0,1,1,3.45,0v2.58h1.73a1.72,1.72,0,1,1,0,3.45Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/app-inspect.svg
// module id = uARr
// module chunks = 264